// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "../../../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function execute(customer_id, wallet_balance, update_amount, updated_at) {
  return {
          customer_id: Belt_Option.getExn(Belt_Int.fromString(customer_id)),
          wallet_balance: Currency.fromCurrency(wallet_balance),
          update_amount: Currency.fromCurrency(update_amount),
          updated_at: Timestamp$Catalyst.toFloat(updated_at)
        };
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
